import {
  Button,
  Col,
  Collapse,
  Descriptions,
  Input,
  Modal,
  Row,
  Space,
  Table,
} from 'antd';
import { InputGroup } from 'react-bootstrap';
import { useContext, useEffect, useState } from 'react';
import Axios from 'axios';
import Excel from 'components/table/excel';
import CustomPagination from 'components/table/pagination';
import DashboardContext from 'Context';
import InputControl from 'components/inputs/InputControl';
import InputDate from 'components/inputs/InputDate';
import InputNumber from 'components/inputs/InputNumber';
import InputControlMulti from 'components/inputs/InputControlMulti';

export default function CustomerReport() {
  const { urldashboard, authentication } = useContext(DashboardContext);

  // table data
  const [data, setData] = useState([]);
  const [record, setRecord] = useState({});
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [searchValue, setSearchValue] = useState('');
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
  });
  // action modals
  const [moreInfoModal, setMoreInfoModal] = useState(false);

  useEffect(() => {
    getCustomersReport({
      page: pagination?.page,
      pageSize: pagination?.pageSize,
      searchValue,
      formData,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getCustomersReport = async ({
    page,
    pageSize,
    searchValue,
    formData,
  }) => {
    setLoading(true);
    try {
      let url = '/customerReport/get';
      const res = await Axios.post(
        urldashboard + url,
        JSON.stringify({
          page,
          pageSize,
          serachCustomer: searchValue,
          ...formData,
        }),
        {
          headers: {
            Authorization: authentication,
            'Content-Type': 'application/json',
          },
        }
      );
      const data = await res.data;
      const items = data?.customerReportResponseItems?.map((obj) => ({
        ...obj,
        key: obj.id,
      }));
      setData(items);
      setTotalRecord(data?.totalRecord);
      setPagination({
        page: page,
        pageSize: pageSize,
        total: data?.totalRecord,
      });
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setData([]);
    }
  };

  const handlePagination = (newPage, newPageSize) => {
    getCustomersReport({
      page: newPage,
      pageSize: newPageSize,
      searchValue,
      formData,
    });
  };

  const search = () => {
    getCustomersReport({
      page: 1,
      pageSize: 10,
      searchValue,
      formData,
    });
  };

  const columns = [
    {
      title: 'ردیف',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg'],
      render: (_, record, index) => (
        <>{index + 1 + (pagination?.page - 1) * pagination?.pageSize}</>
      ),
    },
    {
      title: 'نام مشتری',
      dataIndex: 'customerName',
      key: 'customerName',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'شماره همراه',
      dataIndex: 'phoneNumber',
      key: 'phoneNumber',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'تعداد سفارش',
      dataIndex: 'numberOfOrderSchedule',
      key: 'numberOfOrderSchedule',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'ایجادکننده',
      dataIndex: 'creatorName',
      key: 'creatorName',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'کل فروش (ریال)',
      dataIndex: 'saleAmount',
      key: 'saleAmount',
      responsive: ['xl', 'lg', 'md'],
      render: (value) => <span>{value?.toLocaleString()}</span>,
    },
    {
      title: 'تعداد نیروهای بکار گرفته شده',
      dataIndex: 'numberOfUsedWorkers',
      key: 'numberOfUsedWorkers',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'تعداد کل کار نیروها',
      dataIndex: 'numberOfWorkWorkers',
      key: 'numberOfWorkWorkers',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'تعداد سفارشهای کنسل شده',
      dataIndex: 'numberOfCancelOrder',
      key: 'numberOfCancelOrder',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
    },
    {
      title: 'تاریخ اولین سفارش',
      dataIndex: 'firstOrderDate',
      key: 'firstOrderDate',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'تاریخ آخرین سفارش',
      dataIndex: 'lastOrderDate',
      key: 'lastOrderDate',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (value) => <span>{value ? value : '-'}</span>,
    },
    {
      title: 'نحوه آشنایی',
      dataIndex: 'refererTitle',
      key: 'refererTitle',
      responsive: ['xl', 'lg'],
      render: (value) => <span>{value ?? '-'}</span>,
    },
    {
      title: 'اطلاعات بیشتر',
      dataIndex: 'index',
      key: 'index',
      responsive: ['xl', 'lg', 'md', 'sm', 'xs'],
      render: (_, record) => (
        <Button onClick={() => showInfoModal(record)}>
          <i className='mdi mdi-eye'></i>
        </Button>
      ),
    },
  ];

  // actions

  const showInfoModal = (data) => {
    setRecord(data);
    setMoreInfoModal(true);
  };

  return (
    <>
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1 }}>
          <Collapse defaultActiveKey={['0']}>
            <Collapse.Panel header='جستجو پیشرفته' key='1'>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='سفارش از تاریخ'
                    name='fromDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, fromDate: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='سفارش تا تاریخ'
                    name='toDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, toDate: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='ثبت‌نام از تاریخ'
                    name='fromCustomerCreateDate'
                    handelValue={(_, value) =>
                      setFormData({
                        ...formData,
                        fromCustomerCreateDate: value,
                      })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputDate
                    label='ثبت‌نام تا تاریخ'
                    name='toCustomerCreateDate'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, toCustomerCreateDate: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row gutter={20}>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControl
                    url='/common/profileBusinessTypeDropdown'
                    label='نوع بیزینس کار نیرو'
                    name='profileBusinessType'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, profileBusinessType: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputControlMulti
                    name='referrerIds'
                    url='/referrer/dropdown'
                    label='نحوه آشنایی'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, referrerIds: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputNumber
                    label='تعداد سفارش بیشتر از'
                    name='orderMoreCount'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, orderMoreCount: value })
                    }
                  />
                </Col>
                <Col xl={6} lg={6} md={12} sm={12} xs={24}>
                  <InputNumber
                    label='تعداد سفارش کمتر از'
                    name='orderLessCount'
                    handelValue={(_, value) =>
                      setFormData({ ...formData, orderLessCount: value })
                    }
                  />
                </Col>
              </Row>
              {/* */}
              <Row
                gutter={20}
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  marginTop: 20,
                }}
              >
                <Col xl={6} lg={6} md={24} sm={24} xs={24}>
                  <Button
                    type='primary'
                    style={{ width: '100%' }}
                    loading={loading}
                    onClick={() => search()}
                  >
                    جستجو
                  </Button>
                </Col>
              </Row>
            </Collapse.Panel>
          </Collapse>
        </div>
      </div>

      <Row
        gutter={20}
        style={{
          marginTop: 25,
        }}
      >
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <InputGroup>
            <Input
              placeholder='جستجوی سریع (نام مشتری یا شماره همراه)'
              name='searchValue'
              onChange={(e) => setSearchValue(e.target.value)}
              style={{
                height: '3rem',
                width: '90%',
                display: 'table-cell',
              }}
            />
            <Button
              onClick={search}
              style={{
                height: '3rem',
                width: '10%',
                display: 'table-cell',
                padding: 0,
              }}
            >
              <i className='mdi mdi-magnify'></i>
            </Button>
          </InputGroup>
        </Col>
        <Col xs={24} sm={24} md={24} lg={12} style={{ marginBottom: 20 }}>
          <Space
            wrap
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
            }}
          >
            <Excel
              server
              fileName={'گزارش_مشتریان'}
              url={'/customerReport/getExcel'}
              props={{
                ...formData,
                searchValue,
                page: pagination?.page,
                pageSize: pagination?.pageSize,
              }}
            />
          </Space>
        </Col>
      </Row>

      <Table
        size='small'
        style={{ textAlign: 'right', marginTop: 10 }}
        rowClassName={() => 'center'}
        columns={columns}
        bordered={true}
        dataSource={data}
        loading={loading}
        pagination={false}
        locale={{
          emptyText: 'موردی یافت نشد',
        }}
      />

      {!loading && (
        <CustomPagination
          totalRecord={totalRecord}
          pagination={pagination}
          handlePagination={handlePagination}
        />
      )}

      <Modal
        title='اطلاعات بیشتر'
        closable={false}
        open={moreInfoModal}
        onCancel={() => setMoreInfoModal(false)}
        footer={[
          <Button key='back' onClick={() => setMoreInfoModal(false)}>
            بستن
          </Button>,
        ]}
        bodyStyle={{ maxHeight: 600, overflowY: 'auto' }}
      >
        <Descriptions bordered column={1} size={'small'}>
          <Descriptions.Item label='نام مشتری'>
            {record?.customerName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='شماره همراه'>
            {record?.phoneNumber ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تعداد سفارش'>
            {record?.numberOfOrderSchedule}
          </Descriptions.Item>
          <Descriptions.Item label='ایجادکننده'>
            {record?.creatorName ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='کل فروش (ریال)'>
            {record?.saleAmount?.toLocaleString()}
          </Descriptions.Item>
          <Descriptions.Item label='تعداد نیروهای بکار گرفته شده'>
            {record?.numberOfUsedWorkers}
          </Descriptions.Item>
          <Descriptions.Item label='تعداد کل کار نیروها'>
            {record?.numberOfWorkWorkers}
          </Descriptions.Item>
          <Descriptions.Item label='تعداد سفارشهای کنسل شده'>
            {record?.numberOfCancelOrder}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ اولین سفارش'>
            {record?.firstOrderDate
              ? record?.firstOrderDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='تاریخ آخرین سفارش'>
            {record?.lastOrderDate
              ? record?.lastOrderDate
              : 'اطلاعات وارد نشده'}
          </Descriptions.Item>
          <Descriptions.Item label='نحوه آشنایی'>
            {record?.refererTitle ?? 'اطلاعات وارد نشده'}
          </Descriptions.Item>
        </Descriptions>
      </Modal>
    </>
  );
}
